import { createSlice } from "@reduxjs/toolkit";

const medicalFlowModule = createSlice({
  name: "medicalFlowModule",
  initialState: {
    isLoading: false,
    claims: null,
    report: null,
    isError: false,
  },
  reducers: {
    setMedicalFlowModule_Claims: (state, action) => {
      state.claims = action.payload;
    },
    setMedicalFlowModule_Report: (state, action) => {
      state.report = action.payload;
    },
  },
});

export const { setMedicalFlowModule_Claims, setMedicalFlowModule_Report } =
  medicalFlowModule.actions;
export default medicalFlowModule.reducer;
